var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"grey lighten-2 pt-1"},[(this.editAssignmentData)?_c('EditorNewAssignmentItem',{attrs:{"editMode":true,"editorStartData":_vm.editorStartData}}):_vm._e(),_c('v-card-actions',{staticClass:"px-4 pb-4"},[_c('v-btn',{attrs:{"block":"","color":"secondary"},on:{"click":_vm.handleSaveButton}},[_vm._v("save")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }